import { render, staticRenderFns } from "./top8.vue?vue&type=template&id=2d31cbff&scoped=true"
import script from "./top8.vue?vue&type=script&lang=js"
export * from "./top8.vue?vue&type=script&lang=js"
import style0 from "./top8.vue?vue&type=style&index=0&id=2d31cbff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d31cbff",
  null
  
)

export default component.exports